import type { IClassroomResultRepository } from './interfaces/IClassroomResultRepository'
import type { ClassroomResult } from '@/types'
import { getDocuments, where } from '@/services/firestore'

export class FirestoreClassroomResultRepository implements IClassroomResultRepository {
  async getByClassroomAndStudent(
    classroomId: string,
    studentId: string
  ): Promise<ClassroomResult | null> {
    const results = await getDocuments<ClassroomResult>('classroom_results', [
      where('classroom_id', '==', classroomId),
      where('student_id', '==', studentId),
    ])
    return results[0] ?? null
  }
}
